import React from "react";
import { useScreenSubscription } from "../subscription/screenProviderLocationAccount";
import { AddPaymentMethodBase } from "./addPaymentMethodBase";

export const AddPaymentMethodDynamic = () => {
  const { goBack } = useScreenSubscription();

  return <AddPaymentMethodBase title={''} goBack={goBack} />;
};
